// CustomerDetailsEditable.tsx (Label-Value-Pair style with old/new headings)
import {
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Paper
} from '@mui/material';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectEndorsmentFormData,
  selectPolicyDetails,
  updateEndorsementFormData
} from 'src/features/rfqDataSlice';

function CustomerDetailsEditable() {
  const dispatch = useDispatch();
  const fields = [
    { key: 'insuredName', label: 'Insured Name' },
    { key: 'address', label: 'Full Address' },
    { key: 'branchName', label: 'Branch Name' },
    { key: 'city', label: 'City' },
    { key: 'pincode', label: 'Pincode' },
    { key: 'gstNo', label: 'GST No.' },
  ];

  const endorsementFormData = useSelector(selectEndorsmentFormData);
  const policyDetails = useSelector(selectPolicyDetails);

  const handleChange = (key: string, value: string) => {
    dispatch(updateEndorsementFormData({
      ...endorsementFormData,
      customerData: {
        ...endorsementFormData.customerData,
        [`${key}Value`]: value
      }
    }));
  };

  return (
    endorsementFormData.customerData && (
      <>
        <Box sx={{ mb: 1 }}>
          <Typography
            variant="h5"
            className="heading"
            style={{
              background: 'rgb(9 84 174)',
              color: '#fff',
              paddingTop: '6px',
              paddingBottom: '6px',
              fontWeight: 'bold',
              width: '100%',
              paddingLeft: '16px'
            }}
          >
            Customer Details
          </Typography>
        </Box>

        <TableContainer component={Paper} sx={{ mb: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell style={{width:'470px'}}><strong>Field</strong></TableCell>
                <TableCell style={{width:'450px'}} sx={{ color: 'red' }}><strong>Old Value</strong></TableCell>
                <TableCell sx={{ color: 'green' }}><strong>New Value</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fields.map(({ key, label }) => {
                const isEditable = endorsementFormData.customerData[key];
                const valueKey = `${key}Value`;
                const currentValue = endorsementFormData.customerData[valueKey] || '';
                const oldValue = policyDetails?.customerData?.[key] || 'N/A';

                return (
                  isEditable && (
                    <TableRow key={key}>
                      <TableCell>{label}</TableCell>
                      <TableCell sx={{ color: oldValue !== currentValue ? 'red' : 'inherit' }}>{oldValue}</TableCell>
                      <TableCell>
                        <TextField
                          fullWidth
                          size="small"
                          value={currentValue}
                          onChange={(e) => handleChange(key, e.target.value)}
                        />
                      </TableCell>
                    </TableRow>
                  )
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    )
  );
}

export default CustomerDetailsEditable;
